import { UPDATE_URL } from './url.types';
export var urlUpdated = function urlUpdated() {
  return {
    type: UPDATE_URL
  };
};